"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ArrowIcon = void 0;
const react_1 = __importDefault(require("react"));
const styled_components_1 = __importStar(require("styled-components"));
const Styled = styled_components_1.default.span `
	color: ${(p) => p.theme.palette.accent.text};
	position: ${(p) => (p.relative ? "relative" : "absolute")};
	margin-left: 2px;
	display: inline-block;
	transition: transform 0.2s ${(p) => p.theme.easing};

	&:hover {
		transform: translate3d(0, 0, 0) translateX(${(p) => (p.hoverDirection === "right" ? "4px" : "-4px")});
	}

	&.left {
		i {
			transform: translate3d(0, 0, 0) rotate(180deg);
		}
	}

	&.upright {
		i {
			transform: translate3d(0, 0, 0) rotate(-45deg);
		}
	}

	&.up {
		i {
			transform: translate3d(0, 0, 0) rotate(-90deg);
		}
		&:hover {
			transform: translate3d(0, 0, 0) translateX(0);
		}
	}

	&.down {
		i {
			transform: translate3d(0, 0, 0) rotate(90deg);
		}
		&:hover {
			transform: translate3d(0, 0, 0) translateX(0);
		}
	}

	i {
		display: inline-block;
		font-size: 20px;
		line-height: 16px;
	}
`;
exports.ArrowIcon = (0, styled_components_1.withTheme)(({ face = "right", relative, hoverDirection = "right", theme }) => {
    let icon = "arrow-forward";
    if ((face === "right" || face === "left") && theme.forwardIcon) {
        icon = theme.forwardIcon;
    }
    return (react_1.default.createElement(Styled, { className: `arrow-wrap ${face} ${icon}`, relative: relative, hoverDirection: hoverDirection },
        react_1.default.createElement("i", { className: `eg-header-icon-${icon}` })));
});
//# sourceMappingURL=ArrowIcon.atom.js.map